module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.theForkId) ? _c('div', {
    staticClass: "c-fixed-button-book u-fixed u-pos-bl u-zindex--3 u-hide@sm u-w-vw8of10@sm",
    class: [_vm.isHidden ? 'is-hidden' : 'is-visible']
  }, [_c('app-button-book', {
    attrs: {
      "the-fork-id": _vm.theForkId,
      "label": _vm.label
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-540426c3"}!./src/scripts/components/app-fixed-button-book/template.html
// module id = 195
// module chunks = 0